<sgt-multi-select
  [settings]="settings"
  [options]="options"
  [(ngModel)]="idsEscalasRentabilidade"
  (ngModelChange)="onSelectionChange()"
  (search)="onFilter()"
  (isFirstOpened)="onFirstOpened($event)"
>
  <ng-template #customOptionTemplate let-option>
    <sgt-escala-rentabilidade [id]="escalaIds[option.id]"></sgt-escala-rentabilidade>
    <span class="ml-2">{{ option.label }}</span>
  </ng-template>
</sgt-multi-select>
